/* Otwieranie mega-menu po najechaniu kursorem (tylko urządzenia wskazujące). */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 180;

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (wrapper) {
      if (wrapper.dataset.hoverBound === 'true') return;
      var details = wrapper.querySelector('details');
      if (!details) return;
      wrapper.dataset.hoverBound = 'true';

      var timer;

      function open() {
        if (!fine.matches) return;
        clearTimeout(timer);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
        if (!details.hasAttribute('open')) details.setAttribute('open', '');
      }

      function scheduleClose() {
        if (!fine.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      }

      wrapper.addEventListener('mouseenter', open);
      wrapper.addEventListener('mouseleave', scheduleClose);

      // kliknięcie w nagłówek nie zamyka panelu otwartego najechaniem
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (fine.matches && details.hasAttribute('open')) event.preventDefault();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
